var React = require('react');

function IconYoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.722 6.861v10.277L22.644 12l-8.922-5.139zM3.728 23.265a4.297 4.297 0 01-3.022-3.02A45.475 45.475 0 010 12a45.604 45.604 0 01.706-8.244A4.393 4.393 0 013.728.707C6.38.007 17.03 0 17.138 0c.108 0 10.76.008 13.411.734a4.292 4.292 0 013.015 3.022c.501 2.729.738 5.5.707 8.274a45.465 45.465 0 01-.707 8.244 4.292 4.292 0 01-3.02 3.02c-2.645.698-13.298.706-13.406.706-.108 0-10.73-.008-13.41-.735z","fill":"#2777b8","fillRule":"evenodd"}));
}

IconYoutubeInline.defaultProps = {"viewBox":"0 0 35 24"};

module.exports = IconYoutubeInline;

IconYoutubeInline.default = IconYoutubeInline;
